/**
 * Yan menüden hash/sayfa geçişlerinde:
 * - Menüyü animasyonsuz kapat
 * - View transition / scroll zıplamasını engelle
 * - Sonra güvenli şekilde git
 */
(function () {
  if (!document.getElementById("gx-menu-hash-style")) {
    var style = document.createElement("style");
    style.id = "gx-menu-hash-style";
    style.textContent =
      "header-drawer[data-gx-instant-close] .menu-drawer," +
      "header-drawer[data-gx-instant-close] .menu-drawer__submenu," +
      "header-drawer[data-gx-instant-close] .menu-drawer__backdrop," +
      "header-drawer[data-gx-instant-close] .menu-drawer__animated-element{" +
      "transition:none!important;animation:none!important;}" +
      "header-drawer[data-gx-instant-close] .menu-drawer," +
      "header-drawer[data-gx-instant-close] .menu-drawer__submenu{" +
      "transform:translateX(-100%)!important;visibility:hidden!important;" +
      "opacity:0!important;pointer-events:none!important;}" +
      "header-drawer[data-gx-instant-close] .menu-drawer__backdrop{" +
      "opacity:0!important;pointer-events:none!important;}" +
      "html[data-gx-menu-nav],body[data-gx-menu-nav]{" +
      "overflow:hidden!important;overscroll-behavior:none;}";
    document.head.appendChild(style);
  }

  function normalizePath(pathname) {
    var p = String(pathname || "/").replace(/\/+$/, "");
    return p || "/";
  }

  function forceCloseMenuDrawer() {
    var drawer = document.querySelector("header-drawer");
    if (!drawer) return;

    drawer.setAttribute("data-gx-instant-close", "");

    drawer.querySelectorAll("details").forEach(function (details) {
      details.classList.remove("menu-open");
      details.removeAttribute("open");
      var summary = details.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "false");
    });

    var panel = drawer.querySelector(".menu-drawer");
    if (panel) panel.classList.remove("menu-drawer--has-submenu-opened");

    // Tema :has(details[open]) overflow:hidden — açık kalmasın
    document.documentElement.style.removeProperty("overflow");
    document.body.style.removeProperty("overflow");
  }

  function scrollToHash(hash) {
    var id = decodeURIComponent(String(hash || "").replace(/^#/, ""));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "auto", block: "start" });
  }

  function parseLink(anchor) {
    if (!(anchor instanceof HTMLAnchorElement)) return null;
    var raw = anchor.getAttribute("href");
    if (!raw || raw === "#" || raw.indexOf("javascript:") === 0) return null;
    try {
      return new URL(anchor.href, location.href);
    } catch (e) {
      return null;
    }
  }

  function goTo(url) {
    // View Transition olmadan sert navigasyon
    try {
      document.documentElement.classList.add("gx-skip-vt");
    } catch (e) {
      /* yok */
    }
    window.location.assign(url.href);
  }

  // Collections sayfasına hash ile gelindiyse, yükleme sonrası kaydır
  (function applyPendingHash() {
    try {
      var pending = sessionStorage.getItem("gx-pending-hash");
      if (!pending) return;
      sessionStorage.removeItem("gx-pending-hash");
      if (location.hash !== pending) {
        history.replaceState(null, "", pending);
      }
      requestAnimationFrame(function () {
        scrollToHash(pending);
      });
    } catch (e) {
      /* yok */
    }
  })();

  document.addEventListener(
    "click",
    function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var anchor =
        event.target && event.target.closest
          ? event.target.closest("a[href]")
          : null;
      if (!anchor) return;
      if (!anchor.closest("header-drawer")) return;

      var url = parseLink(anchor);
      if (!url) return;
      if (url.origin !== location.origin) return;

      var samePath =
        normalizePath(url.pathname) === normalizePath(location.pathname);
      var hasHash = Boolean(url.hash && url.hash !== "#");

      // Menü içi tüm iç linklerde: önce kapat, native/VT navigasyonu engelle
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }

      document.documentElement.setAttribute("data-gx-menu-nav", "");
      document.body.setAttribute("data-gx-menu-nav", "");
      forceCloseMenuDrawer();

      if (samePath && hasHash) {
        document.documentElement.removeAttribute("data-gx-menu-nav");
        document.body.removeAttribute("data-gx-menu-nav");
        if (location.hash !== url.hash) {
          history.pushState(null, "", url.hash);
        }
        requestAnimationFrame(function () {
          scrollToHash(url.hash);
        });
        return;
      }

      // Başka sayfa (+ isteğe bağlı hash): menü kapandıktan sonra git
      // Hash'i yükleme sonrası uygula — orta ekran zıplamasını keser
      try {
        if (hasHash) sessionStorage.setItem("gx-pending-hash", url.hash);
        else sessionStorage.removeItem("gx-pending-hash");
      } catch (e) {
        /* yok */
      }

      var target = new URL(url.href);
      if (hasHash) target.hash = "";

      setTimeout(function () {
        goTo(target);
      }, 40);
    },
    true
  );
})();
